import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import zeplinColor from 'theme/Color';
import { PieChart } from '@mui/x-charts';

type BreakdownItem = {
  label: string;
  value: number;
  percentage: number;
  color: string;
};

const CustomPieChart = ({ title, items }: { title: string; items: BreakdownItem[] }) => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm')); // < 600px

  const isXl = useMediaQuery(theme.breakpoints.up('xl')); // 1200px - 1536px
  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', gap: '32px', alignItems: 'center', flex: 1 }}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {items.length > 0 && (
          <PieChart
            sx={{ height: { xs: '12rem', xl: '15rem' }, position: 'relative' }}
            hideLegend
            series={[
              {
                data: items.map((item, index) => ({
                  id: index,
                  value: item.value,
                  label: item.label,
                  color: item.color,
                })),
                innerRadius: isXs ? 80 : isXl ? 90 : 80,
                paddingAngle: 2,
                cornerRadius: 3,
                cx: 110,
              },
            ]}
          />
        )}
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '7rem',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            fontSize: { xs: '24px', xl: '28px' },
            fontWeight: 700,
            color: 'rgba(0, 0, 0, 0.87)',
          }}
        >
          {items.reduce((acc, item) => acc + item.value, 0)}
        </Box>
      </Box>
      <Box sx={{ display: 'flex', gap: '32px' }}>
        {items.map((item) => (
          <Box
            key={item.label}
            sx={{
              display: 'flex',
              gap: '8px',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                backgroundColor: item.color,
              }}
            />
            <Box
              sx={{
                display: 'flex',
                gap: '8px',
                alignItems: 'center',
                justifyContent: 'space-between',
                flex: 1,
              }}
            >
              <Typography variant='responsiveBody3' sx={{ flex: 1 }}>
                {item.label}
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  gap: '4px',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  flex: 1,
                }}
              >
                <Typography variant='responsiveHeading4'>{item.percentage.toFixed(2)}%</Typography>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default CustomPieChart;
